import { useState } from 'react';
import MetricsDashboardFilters from './components/filters';
import { MetricIdeas } from './components/metric-ideas';
import MetricStats from './components/metric-stats';
import MetricsList from './components/metrics-list';
import TotalStatistics from './components/total-statistics';

export function MetricsDashboard() {
  const [channelId, setChannelId] = useState<string>();
  const [projectId, setProjectId] = useState<string>();
  const [challengeId, setChallengeId] = useState<string>();
  const [topicId, setTopicId] = useState<string>();
  const [businessArea, setBusinessArea] = useState<string>();
  const [countryId, setCountryId] = useState<string>();
  const [metricId, setMetricId] = useState<string>();

  const filterOnChange = ({
    channelId,
    projectId,
    challengeId,
    topicId,
    businessArea,
    countryId,
    metricId,
  }: {
    channelId?: string;
    projectId?: string;
    challengeId?: string;
    topicId?: string;
    businessArea?: string;
    countryId?: string;
    metricId?: string;
  }) => {
    channelId !== undefined &&
      setChannelId(channelId === 'ALL' ? undefined : channelId);
    projectId !== undefined &&
      setProjectId(projectId === 'ALL' ? undefined : projectId);
    challengeId !== undefined &&
      setChallengeId(challengeId === 'ALL' ? undefined : challengeId);
    topicId !== undefined &&
      setTopicId(topicId === 'ALL' ? undefined : topicId);
    businessArea !== undefined &&
      setBusinessArea(businessArea === 'ALL' ? undefined : businessArea);
    countryId !== undefined &&
      setCountryId(countryId === 'ALL' ? undefined : countryId);
    metricId !== undefined &&
      setMetricId(metricId === 'ALL' ? undefined : metricId);
  };

  return (
    <div className="space-y-4">
      <MetricsDashboardFilters onChangeFilter={filterOnChange} />
      <MetricsList
        metricId={metricId}
        onChange={(value: any) =>
          filterOnChange({
            metricId: value,
          })
        }
      />
      <TotalStatistics
        channelId={channelId}
        projectId={projectId}
        challengeId={challengeId}
        topicId={topicId}
        businessArea={businessArea}
        countryId={countryId}
        metricId={metricId}
      />
      <MetricStats
        channelId={channelId}
        projectId={projectId}
        challengeId={challengeId}
        topicId={topicId}
        businessArea={businessArea}
        countryId={countryId}
        metricId={metricId}
      />
      <MetricIdeas
        channelId={channelId}
        projectId={projectId}
        challengeId={challengeId}
        topicId={topicId}
        businessArea={businessArea}
        countryId={countryId}
        metricId={metricId}
      />
    </div>
  );
}
